import { createSlice } from "@reduxjs/toolkit";
import { VDBIcons } from "@utils/VDBIcons";
import { Platform } from "react-native";
import { useSelector } from "react-redux";
import { ScreenSizes } from "../../types/screen";
import { useMemo } from "react";

const exploreTabOptions = [
  {
    icon: {
      data: "upd-diamonds",
      type: "svg",
      icon_color: "diam-01",
    },
    name: "diamond",
    label: "navigation.search.explore.naturalDiamond",
    order: 2,
    component: "ExploreNavigator",
    price_modes: [0, 1, 2],
    acceptedScreenSizes: [ScreenSizes.LARGE],
    focusedColorCode: "diam-02",
    productType: "diamond",
  },
  {
    icon: {
      data: "upd-labGrown",
      type: "svg",
      icon_color: "lab-01",
    },
    name: "lab_grown_diamond",
    label: "navigation.search.explore.label.labgrownDiamond",
    order: 3,
    component: "ExploreNavigator",
    price_modes: [0, 1, 2],
    acceptedScreenSizes: [ScreenSizes.LARGE],
    focusedColorCode: "lab-02",
    productType: "lab_grown_diamond",
  },
  {
    icon: {
      data: "upd-gemstones",
      type: "svg",
      icon_color: "gem-01",
    },
    name: "gemstone",
    label: "navigation.search.explore.gemstone.label",
    order: 4,
    component: "ExploreNavigator",
    price_modes: [0, 1, 2],
    acceptedScreenSizes: [ScreenSizes.LARGE],
    focusedColorCode: "gem-02",
    productType: "gemstone",
  },
  {
    icon: {
      data: "upd-jewelry",
      type: "svg",
      icon_color: "jewelry-01",
    },
    name: "jewelry",
    label: "navigation.search.explore.jewelry.label",
    order: 5,
    component: "ExploreNavigator",
    price_modes: [0, 1, 2],
    sectionName: "Jewelry",
    acceptedScreenSizes: [ScreenSizes.LARGE],
    focusedColorCode: "jewelry-02",
    productType: "jewelry",
  },
  {
    icon: {
      data: "upd-labJewelry",
      type: "svg",
      icon_color: "jewelry-01",
    },
    name: "lab-grown-jewelry",
    label: "navigation.search.explore.labgrownjewelry.label",
    order: 6,
    component: "ExploreNavigator",
    price_modes: [0, 1, 2],
    sectionName: "Lab-Grown Jewelry",
    acceptedScreenSizes: [ScreenSizes.LARGE],
    focusedColorCode: "jewelry-02",
    productType: "jewelry",
  },
];

const initialState = {
  header: {
    backgroundColor: "core-03",
    htmlHeader: null,
    height: "114",
    left: {
      width: "30%",
      items: [
        {
          name: "logo",
          url: "https://d4e0znfezoh8f.cloudfront.net/uploads/organization/secondary_logo_url/1/mobile-login-logo__1_.svg",
          link: null,
        },
      ],
    },
    center: {
      items: [],
    },
    right: {
      width: "30%",
      items: [
        {
          name: "bulk-list",
          icon: "bulk-list-shopping-cart",
          iconPosition: "left",
          label: "navigationMenu.web.bulkList.text",
        },
        {
          name: "search",
          icon: "main-search",
          iconPosition: "left",
          label: "explore.title.text",
        },
        {
          name: "profile",
          icon: "profile",
          iconPosition: "left",
        },
      ],
    },
  },
  sections: [
    {
      icon: {
        data: VDBIcons.HOME,
        type: "svg",
      },
      name: "homeScreen",
      type: "container",
      label: "navigation.bottomBar.home",
      order: 1,
      component: "HomeNavigator",
      price_modes: [0, 1, 2],
      sub_section: [],
      is_default_screen: true,
      acceptedScreenSizes: [
        ScreenSizes.LARGE,
        ScreenSizes.TABLET,
        ScreenSizes.MOBILE,
      ],
      focusedColorCode: "main-02",
    },
    // ...exploreTabOptions,
    {
      icon: {
        data: VDBIcons.FAV,
        type: "svg",
      },
      name: "favorites",
      type: "container",
      label: "navigation.bottomBar.favorites",
      order: Platform.OS === "web" ? 8 : 7,
      component: "FavoritesNavigator",
      sub_section: [],
      price_modes: [0, 1, 2],
      acceptedScreenSizes: [
        ScreenSizes.LARGE,
        ScreenSizes.TABLET,
        ScreenSizes.MOBILE,
      ],
      focusedColorCode: "error-01",
    },
    {
      icon: {
        data: VDBIcons.MAIN_SEARCH,
        type: "svg",
      },
      name: "search",
      type: "bottom_bar_up_icon",
      label: "navigation.bottomBar.explorer",
      order: Platform.OS === "web" ? 7 : 8,
      on_click: "",
      component: "ExploreNavigator",
      price_modes: [0, 1, 2],
      sub_section: [
        {
          icon: {
            data: VDBIcons.MAIN_SEARCH,
            type: "svg",
          },
          name: "search_bar",
          type: "text_input",
          label: "explore.searchbox.text",
          order: 1,
          on_change: "performSearch(query)",
          placeholder: "navigation.searchBar.placeholder",
          price_modes: [0, 1, 2],
          sub_section: [],
          response_key: "",
        },
        {
          name: "explore_and_saved",
          type: "tabs",
          label: "",
          order: 2,
          icon_url: "",
          component: "TabScreen",
          on_change: "",
          placeholder: "",
          price_modes: [0, 1, 2],
          sub_section: [
            {
              icon: {
                data: "www.sd",
                type: "font",
              },
              name: "explore",
              type: "nav_option",
              label: "explore.exploreTab.text",
              order: 1,
              options: exploreTabOptions,
              component: "ExploreScreen",
              on_change: "",
              placeholder: "",
              price_modes: [0, 1, 2],
              response_key: "",
            },
            {
              name: "saved_searches",
              type: "nav_option",
              label: "explore.savedSearchTab.text",
              order: 2,
              icon_url: "",
              on_change: "",
              placeholder: "",
              price_modes: [0, 1, 2],
              sub_section: [],
              response_key: "",
            },
          ],
          response_key: "",
        },
      ],
      response_key: "",
      acceptedScreenSizes: [
        ScreenSizes.LARGE,
        ScreenSizes.TABLET,
        ScreenSizes.MOBILE,
      ],
      focusedColorCode: "main-02",
    },
    {
      icon: {
        data: VDBIcons.REQUEST_HISTORY,
        type: "svg",
      },
      name: "requests",
      type: "container",
      label: "navigation.bottomBar.requests",
      order: 9,
      icon_url: "",
      component: "RequestHistoryNavigator",
      price_modes: [0, 1, 2],
      sub_section: [],
      acceptedScreenSizes: [
        ScreenSizes.LARGE,
        ScreenSizes.TABLET,
        ScreenSizes.MOBILE,
      ],
      focusedColorCode: "main-02",
    },
    {
      icon: {
        data: "profile",
        type: "svg",
      },
      name: "profile",
      type: "container",
      label: "navigation.bottomBar.profile",
      order: 10,
      component: "MoreNavigator",
      price_modes: [0, 1, 2],
      sub_section: [
        {
          icon: {
            data: "",
            type: "more",
          },
          name: "general",
          type: "small_container",
          label: "navigation.search.profile.label.general",
          order: 1,
          options: [
            {
              icon: {
                data: "",
                type: "image",
              },
              name: "price_mode",
              type: "clickable_icon",
              label: "navigation.profile.general.label.priceMode",
              order: 1,
              on_click: "OpenPriceProfileVisibility",
              component: "PriceProfileScreen",
              extra_css: {
                label: "text:bold",
                response: "font-family:italica;",
              },
              price_modes: [0, 1, 2],
              response_key: "",
            },
            {
              icon: {
                data: "",
                type: "image",
              },
              name: "default_search_group",
              type: "clickable_icon",
              label: "navigation.profile.general.label.searchGroup",
              order: 2,
              on_click: "",
              component: "SearchGroupScreen",
              extra_css: {
                label: "text:bold",
                response: "font-family:italica;",
              },
              price_modes: [0, 1, 2],
              response_key: "group_name",
            },
            {
              icon: {
                data: "",
                type: "image",
              },
              name: "biometrics",
              label: "navigation.profile.general.label.authorization",
              order: 2,
              on_click: "",
              component: "AuthorizationScreen",
              extra_css: {
                label: "text:bold",
                response: "font-family:italica;",
              },
              price_modes: [0, 1, 2],
              response_key: "stock_num",
            },
          ],
          component: "GeneralScreen",
          price_modes: [0, 1, 2],
        },
        {
          icon: {
            data: "",
            type: "font",
          },
          name: "languageCurrency",
          type: "small_container",
          label: "navigation.search.explore.label.labgrownDiamond",
          order: 2,
          options: [
            {
              icon: {
                data: "",
                type: "image",
              },
              name: "languages",
              type: "clickable_icon",
              label: "navigation.profile.general.label.language",
              order: 1,
              on_click: "OpenLanguageSelection",
              component: "LanguageScreen",
              extra_css: {
                label: "text:bold",
                response: "font-family:italica;",
              },
              price_modes: [0, 1, 2],
              response_key: "language",
            },
            {
              icon: {
                data: "",
                type: "image",
              },
              name: "currency",
              type: "clickable_icon",
              label: "navigation.profile.general.label.currency",
              order: 2,
              on_click: "",
              component: "currencyScreen",
              extra_css: {
                label: "text:bold",
                response: "font-family:italica;",
              },
              price_modes: [0, 1, 2],
              response_key: "currency",
            },
          ],
          component: "LanguageCurrencyScreen",
          price_modes: [0, 1, 2],
        },
        {
          icon: {
            data: "",
            type: "font",
          },
          name: "integrations",
          type: "small_container",
          label: "navigation.profile.label.integration",
          order: 3,
          options: [
            {
              icon: {
                data: "",
                type: "image",
              },
              name: "jbt_id",
              type: "clickable_icon",
              label: "navigation.profile.general.label.linkJbt",
              order: 1,
              on_click: "OpenJbt",
              component: "JBTScreen",
              extra_css: {
                label: "text:bold",
                response: "font-family:italica;",
              },
              price_modes: [0, 1, 2],
              response_key: "",
            },
          ],
          component: "IntegrationsScreen",
          price_modes: [0, 1, 2],
        },
        {
          icon: {
            data: "",
            type: "font",
          },
          name: "other",
          type: "small_container",
          label: "navigation.profile.label.other",
          order: 4,
          options: [
            {
              icon: {
                data: "",
                type: "image",
              },
              name: "terms_of_use",
              type: "clickable_icon",
              label: "navigation.profile.general.label.terms",
              order: 1,
              on_click: "OpenTermOfService",
              component: "TermsScreen",
              extra_css: {
                label: "text:bold",
                response: "font-family:italica;",
              },
              price_modes: [0, 1, 2],
              response_key: "",
            },
            {
              icon: {
                data: "",
                type: "image",
              },
              name: "contact_us",
              type: "clickable_icon",
              label: "navigation.profile.general.label.contact_us",
              order: 2,
              on_click: "",
              component: "ContactScreen",
              extra_css: {
                label: "text:bold",
                response: "font-family:italica;",
              },
              price_modes: [0, 1, 2],
              response_key: "",
            },
            {
              icon: {
                data: "",
                type: "image",
              },
              name: "delete_account",
              label: "navigation.profile.general.label.deleteAccount",
              order: 3,
              on_click: "",
              component: "DeleteAccountScreen",
              extra_css: {
                label: "text:bold",
                response: "font-family:italica;",
              },
              price_modes: [0, 1, 2],
              response_key: "",
            },
            {
              icon: {
                data: "",
                type: "image",
              },
              name: "logout",
              label: "navigation.profile.general.label.signOut",
              order: 4,
              on_click: "api.signout",
              component: "SignoutScreen",
              extra_css: {
                label: "text:bold",
                response: "font-family:italica;",
              },
              price_modes: [0, 1, 2],
              response_key: "",
            },
          ],
          component: "OtherScreen",
          price_modes: [0, 1, 2],
        },
      ],
      acceptedScreenSizes: [ScreenSizes.TABLET, ScreenSizes.MOBILE],
      focusedColorCode: "main-02",
    },
  ],
};

const navigationMenuDataSlice = createSlice({
  name: "navigationMenu",
  initialState,
  reducers: {
    saveNavigationData: (state, action) => {
      return {
        ...state,
        ...action.payload,
        updatedTime: new Date().toISOString(),
      };
    },
    clearNavigationData: (state) => {
      state.sections = initialState.sections;
    },
  },
});

export const useNavigationMenuSlice = () => {
  const navigationData = useSelector((state: any) => state.navigationMenu);

  const headerData = useMemo(() => {
    return navigationData?.header ?? null;
  }, [navigationData?.header]);

  const getFilterData = (searchText: string): Array<any> => {
    const filteredArray = navigationData.sections.filter(
      (item) => item.name === searchText
    );

    return filteredArray;
  };

  const getHeaderData = () => headerData;

  const getDefaultScreen = (): Array<any> => {
    const filteredArray = navigationData.sections.filter(
      (item) => item?.is_default_screen === true
    );

    return filteredArray;
  };

  return {
    navigationData,
    getFilterData,
    getDefaultScreen,
    getHeaderData,
  };
};
export const { saveNavigationData, clearNavigationData } =
  navigationMenuDataSlice.actions;
export default navigationMenuDataSlice.reducer;
